import { lighter } from './Design.js';

export class LoadScreen extends Phaser.Scene {
    constructor ()
    {
        super({ key: 'LoadScreen', active: true });
    }

    create ()
    {
        this.add.text(this.game.canvas.width/4, this.game.canvas.height/5, 'Lade das Spiel...', lighter);
    }
}